export default "__VITE_ASSET__BiEuxqma__"